import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addTax, updateTax } from "../../../redux/reducers/taxSlice";
import { FaPlus, FaRegEdit } from "react-icons/fa";
import Spinner from "../../../components/Spinner";

export default function AddTax({ type, data }) {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const selectedBusiness = useSelector((state) => state.business.selectedBusiness);
    const { loading } = useSelector((state) => state.tax);
    const businessId = selectedBusiness?._id || localStorage.getItem("activeBusinessId");

    const [formData, setFormData] = useState({
        name: "",
        percentage: "",
        status: "active",
    });

    useEffect(() => {
        if (type === "update" && data) {
            setFormData({
                name: data.name,
                percentage: data.percentage,
                status: data.status,
            });
        }
    }, [type, data]);

    const handleClose = () => {
        if (loading) return;
        setShow(false);
        if (type === "add") {
            setFormData({ name: "", percentage: "", status: "active" });
        }
    };

    const handleShow = () => setShow(true);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = { ...formData, businessId };
        if (type === "update") {
            dispatch(updateTax({ ...payload, id: data._id })).then((res) => {
                if (!res.error) handleClose();
            });
        } else {
            dispatch(addTax(payload)).then((res) => {
                if (!res.error) handleClose();
            });
        }
    };

    return (
        <div className="d-inline-block">
            {type === "add" ? (
                <Button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleShow}>
                    <FaPlus /> New Tax
                </Button>
            ) : (
                <div onClick={handleShow} className="action-icon-edit text-primary p-2 rounded-circle bg-light d-flex align-items-center justify-content-center cursor-pointer" title="Edit Tax">
                  <FaRegEdit size={16} />
                </div>
            )}

            <Modal 
              show={show} 
              onHide={handleClose} 
              centered 
              backdrop="static"
              className="premium-modal"
            >
                <Modal.Header closeButton={!loading} className="border-0 pb-0">
                    <Modal.Title className="fw-bold brand-header">
                        {type === "update" ? "Update Tax" : "Create New Tax"}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body className="pt-4">
                        <Spinner active={loading}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-medium text-secondary small">Tax Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="e.g. VAT, Service Tax"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="gbl-input"
                                    disabled={loading}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-medium text-secondary small">Percentage (%) <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    name="percentage"
                                    placeholder="0.00"
                                    step="0.01"
                                    value={formData.percentage}
                                    onChange={handleChange}
                                    required
                                    className="gbl-input"
                                    disabled={loading}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 border-top pt-3">
                                <Form.Label className="fw-medium text-secondary small">Status</Form.Label>
                                <Form.Select 
                                  name="status" 
                                  value={formData.status} 
                                  onChange={handleChange} 
                                  className="gbl-input"
                                  disabled={loading}
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </Form.Select>
                            </Form.Group>
                        </Spinner>
                    </Modal.Body>
                    <Modal.Footer className="border-0 pt-0 pb-4 px-4 d-flex justify-content-end gap-2">
                        <Button 
                          variant="light" 
                          onClick={handleClose} 
                          className="px-4 fw-bold text-secondary rounded-pill"
                          disabled={loading}
                        >
                            Cancel
                        </Button>
                        <Button 
                          type="submit" 
                          className="btn btn-primary px-4 rounded-pill fw-bold"
                          disabled={loading}
                        >
                            {loading ? "Saving..." : (type === "update" ? "Update Tax" : "Create Tax")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
